<template>
  <div class="cookies-content" v-show="showCookiesModal">
    <div class="container-fluid font-20 white padding-40">
      <div class="row">
        <div class="col-md-10 col-md-offset-1  margin-bottom-20">
          Nós usamos cookies, para melhorar a experiência do usuário em nosso site. Você pode encontrar mais informações na nossa
          <router-link :to="{ name: 'privacy_policy' }" target="_blank" class="white">políticas de privacidade</router-link>.
          <br>
          Clicando em Aceitar você está concordando com nossa politica de privacidade e com a utilização dos cookies e outras ferramentas necessárias para melhorar sua experiência.
        </div>
        <hr>
        <div class="row">
          <div class="col-md-12 text-right">
            <button class="btn btn-default" @click="setCookie">Aceitar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiesModal',
  data () {
    return {
      showCookiesModal: false
    }
  },
  created () {
    if (!this.getCookie()) {
      this.showCookiesModal = true
    }
  },
  methods: {
    getCookie () {
      return this.$cookie.get('privacySettings')
    },
    setCookie () {
      this.$cookie.set('privacySettings', JSON.stringify({
        v: 1,
        t: Date.now(),
        consent: ['NECESSARY']
      }), { expires: '1Y' })
      this.showCookiesModal = false
    }
  }
}
</script>

<style scoped>
  .cookies-content {
    position: fixed;
    bottom: 0;
    background-color: #ff7f00;
    width: 100%;
    min-height: 200px;
    z-index: 9999;
    box-shadow: 0 -4px 4px rgb(0 0 0 / 15%);
    left: 0;
  }
  hr {
    width: 100%;
    border: none;
    border-top: 4px solid #272729;
  }

  input {
    margin: 0 !important;
  }

  a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// CookiesModal.vue?9f41f09c